// extracted by mini-css-extract-plugin
export default {"SponsorItem":"SponsorItem_SponsorItem__MjZT5"};